import client from '../../client'

export interface Params {
  code?: string
  code2?: string
}

export interface Data {
  user: {
    name1: string
    name2: string
    kana1: string
    kana2: string
    sex: number | null
    birthdayYear: string
    birthdayMonth: string
    zip: string
    prefecture: number | null
    address1: string
    address2: string
    addressOther: string
    tel: string
    highSchPrefecture: number | null
    highSchNpp: number | null
    highSchName: string
    grade: number | null
    email: string
    hopeCourse: number | null
    hopeDepart1: number | null
    hopeDepart2: number | null
    hopeArea: number | null
  }
  cart: string[] /** 学校IDの配列 e.g. ['D100001'] */
}

export type Response = unknown

export async function validate(data: Data, params: Params) {
  return client.post<Response>('valid_request_appli_data', { form: data }, { params }).then(({ data }) => data)
}
